import { render } from "./LoginEmail.vue?vue&type=template&id=5126bdc3&scoped=true"
import script from "./LoginEmail.vue?vue&type=script&lang=js"
export * from "./LoginEmail.vue?vue&type=script&lang=js"

import "./LoginEmail.vue?vue&type=style&index=0&id=5126bdc3&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5126bdc3"]])

export default __exports__